/* eslint-disable no-unused-vars */
import { createElement, Fragment } from 'react'
import { remark } from 'remark'
import remarkGfm from 'remark-gfm'
import remarkToRehype from 'remark-rehype'
import rehypeReact from 'rehype-react'

const DEFAULT_REHYPE_OPTIONS = {}

export const useMarkdown = (source, _options = {}) => {
  if (!source) return null
  return remark()
    .use(remarkGfm)
    .use(remarkToRehype)
    .use(rehypeReact, {
      createElement,
      Fragment
    })
    .processSync(source).result
}
